module.exports = __webpack_public_path__ + "static/media/cor.7fd70e82.jpeg";